export default {
  metaInfo () {
    let returnObj = {
      title        : this.MetaData.title,
      titleTemplate: '%s | ' + this.MetaData.loc,
      link         : [
        { vmid: 'canonical', rel: 'canonical', href: this.MetaData.url },
        //{ vmid: 'fav_icon', rel: 'icon', href: this.MetaData.fav },
      ],
      meta         : [
        { vmid: 'application-name', name: 'application-name', content: this.MetaData.loc },
        { vmid: 'og:url', property: 'og:url', content: this.MetaData.url },

        // Facebook / Open Graph1
        { vmid: 'og:title', property: 'og:title', content: this.MetaData.title + ' | ' + this.MetaData.loc },
        { vmid: 'og:site_name', property: 'og:site_name', content: this.MetaData.loc },
        { vmid: 'og:type', property: 'og:type', content: 'website' },
        { vmid: 'og:url', property: 'og:url', content: this.MetaData.url },

        // Twitter Card
        { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
        { vmid: 'twitter:site', name: 'twitter:site', content: this.MetaData.url },
        { vmid: 'twitter:title', name: 'twitter:title', content: this.MetaData.title + ' | ' + this.MetaData.loc },

        // Google / Schema.org markup:
        { vmid: 'google:name', itemprop: 'name', content: this.MetaData.title + ' | ' + this.MetaData.loc },
      ],
    }

    if (this.MetaData.desc) {
      returnObj.meta.push({ vmid: 'description', name: 'description', content: this.MetaData.desc })
      returnObj.meta.push({ vmid: 'og:description', property: 'og:description', content: this.MetaData.desc })
      returnObj.meta.push({ vmid: 'twitter:description', name: 'twitter:description', content: this.MetaData.desc })
      returnObj.meta.push({ vmid: 'google:description', itemprop: 'description', content: this.MetaData.desc })
    }

    if (this.MetaData.keywords) {
      returnObj.meta.push({ vmid: 'keywords', name: 'keywords', content: this.MetaData.keywords })
    }

    if (this.MetaData.img) {
      returnObj.meta.push({ vmid: 'og:image', property: 'og:image', content: this.MetaData.img })
      returnObj.meta.push({ vmid: 'twitter:image:src', name: 'twitter:image:src', content: this.MetaData.img })
      returnObj.meta.push({ vmid: 'google:image', itemprop: 'image', content: this.MetaData.img })
    }

    return returnObj
  },
  methods : {
    changeLanguage (lang) {
      let route = Object.assign({}, this.$route)
      route.params.lang = lang
      this.$router.push(route)
    },
  },
  watch   : {},
  computed: {
    domain () {
      return this.$DataStore.Settings.domain || ''
    },
    MetaTitle () {
      return this.$te(`${ this.$route.name }.Meta.Title`) ? this.$t(`${ this.$route.name }.Meta.Title`) : this.title ? this.title : ''
    },
    MetaDesc () {
      return this.$te(`${ this.$route.name }.Meta.Desc`) ? this.$t(`${ this.$route.name }.Meta.Desc`) : this.desc ? this.desc : ''
    },
    MetaLoc () {
      return this.$t('Common.App.Title')
    },
    MetaUrl () {
      return `https://${ this.domain }/${ this.$route.path }`
    },
    /*MetaFavIcon () {
      return `https://${ this.domain }/favicon.ico`
    },*/
    MetaImage () {
      return (this.$te(`${ this.$route.name }.Meta.Img`) ? ('https://' + this.domain + this.$t(`${ this.$route.name }.Meta.Img`).split(',')[0]) : this.img ? ('https://' + this.domain + '/' + this.img) : '')
    },
    MetaKeywords () {
      return this.$te(`${ this.$route.name }.Meta.keywords`) ? this.$t(`${ this.$route.name }.Meta.keywords`) : this.keywords ? this.keywords : []
    },

    MetaData () {
      return {
        title   : this.MetaTitle,
        desc    : this.MetaDesc,
        loc     : this.MetaLoc,
        url     : this.MetaUrl,
        img     : this.MetaImage,
        //fav     : this.MetaFavIcon,
        keywords: this.MetaKeywords.join(','),
      }
    },
  },
  mounted () {
  },
  destroyed () {
  }

}
